import type { RiskLevel } from "../types";
import { colors, riskColors, fonts } from "../tokens";

interface Props {
  score: number;
  level: RiskLevel;
  size?: number;
}

export function ScoreRing({ score, level, size = 160 }: Props) {
  const r = (size - 14) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (score / 100) * circ;
  const col = riskColors[level] ?? colors.amber;

  return (
    <div style={{ position: "relative", width: size, height: size, margin: "0 auto" }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={colors.border} strokeWidth="5" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={col} strokeWidth="5"
          strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.8s ease-out" }} />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontFamily: fonts.mono, fontSize: size * 0.3, fontWeight: 700, color: col, lineHeight: 1 }}>
          {Math.round(score)}
        </span>
        <span style={{ fontFamily: fonts.mono, fontSize: 8, letterSpacing: "0.18em", textTransform: "uppercase", color: col, marginTop: 3 }}>
          {level}
        </span>
      </div>
    </div>
  );
}
